import { user } from '@/modules/configuracoes/funcionario/store/';
import PermissionValidatorService from './service';

async function valPermissaoCommonWithException(codigoTela, tipoAcesso) {
  const inputModel = {
    funcionario: user.value,
    telaCodigo: codigoTela,
    tipo: tipoAcesso,
  };
  await PermissionValidatorService.valPermissaoWithException(inputModel);
}

async function valPermissaoNegativaBooleanCommon(codigoTela, tipoAcesso) {
  const inputModel = {
    funcionario: user.value,
    telaCodigo: codigoTela,
    tipo: tipoAcesso,
  };
  return new Promise((resolve) => {
    PermissionValidatorService.valPermissaoNegativaBoolean(inputModel).then((data) => {
      resolve(data);
    });
  });
}

async function valPermissaoCommon(codigoTela, tipoAcesso) {
  const inputModel = {
    funcionario: user.value,
    telaCodigo: codigoTela,
    tipo: tipoAcesso,
  };
  return new Promise((resolve) => {
    PermissionValidatorService.valPermissao(inputModel).then((data) => {
      resolve(data);
    });
  });
}

async function valPermissaoNegativaWithExceptionForbidden(codigoTela, tipoAcesso) {
  const inputModel = {
    funcionario: user.value,
    telaCodigo: codigoTela,
    tipo: tipoAcesso,
  };
  await PermissionValidatorService.valPermissaoNegativaWithExceptionForbidden(inputModel);
}

async function valPermissaoObrigatoriedade(codigoTela, tipoAcesso) {
  const inputModel = {
    funcionario: user.value,
    telaCodigo: codigoTela,
    tipo: tipoAcesso,
  };
  return new Promise((resolve) => {
    PermissionValidatorService.valPermissaoObrigatoriedade(inputModel).then((data) => {
      resolve(data);
    });
  });
}

export { PermissionValidatorService, valPermissaoCommonWithException, valPermissaoNegativaBooleanCommon, valPermissaoCommon, valPermissaoNegativaWithExceptionForbidden, valPermissaoObrigatoriedade };
